import React from 'react';
import { Form, Input } from 'antd';
import { FormItem, RowWrapper } from 'component/form_component/style';

export default function Organization({ formTab3, singleUserData, className }) {
  return (
    <Form
      className={className}
      form={formTab3}
      layout='vertical'
      initialValues={{
        jobTitle: singleUserData?.jobTitle ? singleUserData.jobTitle : '',
        department: singleUserData?.department ? singleUserData.department : '',
        company: singleUserData?.company ? singleUserData.company : '',
      }}
    >
      <RowWrapper className={`${className} row-wrapper1`}>
        <FormItem
          key='jobTitle'
          name='jobTitle'
          label='Job Title'
          className={`${className} organization-form-item organization-form-item_job_title`}
        >
          <Input className={`${className} organization-form-input organization-form-input_job_title`} />
        </FormItem>

        <FormItem
          key='department'
          name='department'
          label='Department'
          className={`${className} organization-form-item organization-form-item_department`}
        >
          <Input className={`${className} organization-form-input organization-form-input_department`} />
        </FormItem>
      </RowWrapper>
      <RowWrapper className={`${className} row-wrapper2`}>
        <FormItem
          className={`${className} organization-form-item organization-form-item_company oddFormItem`}
          key='company'
          name='company'
          label='Company'
        >
          <Input className={`${className} organization-form-input organization-form-input_company`} />
        </FormItem>
      </RowWrapper>
    </Form>
  );
}
